<template>
  <div class="order">
    <div class="head">
      <AppFrame/>
      <div class="truckContent">
        <div class="advancedSearch">
          <div class="searchContent">
            <div class="searchTime">
              <div class="startTime">
                <van-field
                  v-model="begin_date"
                  readonly
                  clickable
                  placeholder="开始时间"
                  @click="openDatePicker(1)"
                />
              </div>
              <div class="middle">至</div>
              <div class="endTime">
                <van-field
                  v-model="end_date"
                  readonly
                  clickable
                  placeholder="结束时间"
                  @click="openDatePicker(0)"
                />
              </div>
            </div>
            <div class="searchVehicle">
              <!-- <span class="vehicleNo">陕A12345</span> -->
              <van-field
                  v-model="licensePlate"
                  readonly
                  clickable
                  label="车牌号"
                  placeholder="请选择车牌号"
                  @click="showPickerPlate = true"
                />
            </div>
          </div>
          <div class="searchBtn" @click="toSearch">开始搜索</div>
        </div>
      </div>
    </div>
    <div class="cont">
      <van-tabs v-model="active" @click="onClick">
        <van-tab v-for="(item,index) in tabs" :key="index" :name="item.id" :title="item.label">
        </van-tab>
      </van-tabs>
      <div>
        <!-- 列表页 -->
        <sendcars-order-list :channel="status"></sendcars-order-list>
      </div>
    </div>
    <!-- 选择时间 -->
    <van-popup v-model="showPickerDate" position="bottom" safe-area-inset-bottom>
      <van-datetime-picker
        type="date"
        title="选择时间"
        v-model="datetime"
        cancel-button-text="清除"
        @confirm="onConfirmDate"
        @cancel="onCancelDate"
      ></van-datetime-picker>
    </van-popup>
    <!-- 选择车牌号 -->
    <van-popup v-model="showPickerPlate" safe-area-inset-bottom>
      <plateNumber @getPlateLicense="getPlateLicense"></plateNumber>
    </van-popup>
  </div>
</template>

<script>
import AppFrame from '@/components/AppFrame'
import SendcarsOrderList from '../../components/List/SendcarsOrderList'
import plateNumber from '../../components/PlateNumber'
export default {
  name: "SendcarsOrder",
  components: {
    SendcarsOrderList,
    AppFrame,
    plateNumber
  },
  data() {
    return {
      showPickerDate: false,  // 开始时间显示隐藏
      showPickerPlate: false, // 车牌号显示隐藏
      timePick: 0,        // 选择时间类型
      datetime: new Date(),       //默认时间
      begin_date: '',     //装货时间起始yyyy-MM-dd
      end_date: '',       //装货时间结束yyyy-MM-dd
      licensePlate: '',   //车牌号
      status:'',
      active:-1,
      tabs: [
        {
            id:'-1',
            label:'全部',
        },
        {
            id:'0',
            label:'未开始',
        },
        {
            id:'1',
            label:'已接单',
        },
        {
            id:'2',
            label:'运输中',
        },
        {
            id:'3',
            label:'已到达',
        }
      ],
    };
  },
  created() {
  },
  mounted() {
  },
  methods: {
    openDatePicker(e) {
      if (!this.begin_date && !e) return this.$toast.fail('请先选择开始时间')
      this.showPickerDate = true
      this.timePick = e
    },
    // 选择开始时间
    onConfirmDate(val){
        if(this.timePick){
          this.begin_date = this.$options.filters.timeFormat(new Date(val).getTime(),'yyyy-mm-dd')
        }else{
          this.end_date = this.$options.filters.timeFormat(new Date(val).getTime(),'yyyy-mm-dd')
        }
        this.showPickerDate = false
    },
    // 选择开始时间
    onCancelDate(val){
        if(this.timePick){
          this.begin_date = ''
          this.end_date = ''
        }else{
          this.end_date = ''
        }
        this.showPickerDate = false
    },
    // 选择车牌
    getPlateLicense(data){
      console.log('组件传出的data',data)
      this.licensePlate = data
      this.showPickerPlate = false
    },
    // 切换tabs
    onClick(name, title) {
      this.status = name
      this.bus.$emit('sendcarsOrderTabsId', {
        sendcarsOrderTabsId: name
      })
    },
    toSearch() {
      this.bus.$emit('searchObj', {
        begin_date: this.begin_date,
        end_date: this.end_date,
        licensePlate: this.licensePlate
      })
    }
  },
  destroyed() {
  }
};
</script>
<style scoped lang="less">
  @import '../../styles/order.less';
</style>



// WEBPACK FOOTER //
// src/pages/Invoice/SendcarsOrder.vue